import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import imgHeader from '../../images/header-small.png';
import * as actions from './redux/actions';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SimpleTable from '../common/SimpleTable';
import SimpleRawTable from '../common/SimpleRawTable';
import moment from 'moment'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import {getEnabledFilters} from '../common/util'
import FilterCombo from './FilterCombo';
import Typography from '@material-ui/core/Typography';
import SaveIcon from '@material-ui/icons/Save';
import SyncIcon from '@material-ui/icons/Sync';
import InfoIcon from '@material-ui/icons/Info';
import PublishIcon from '@material-ui/icons/Publish';
import CancelIcon from '@material-ui/icons/Cancel';
import LockIconOutlined from '@material-ui/icons/LockOutlined';
import LockIcon from '@material-ui/icons/Lock';
import AssignmentForm from './AssignmentForm'
import CostStatistics from './CostStatistics'
import {getError } from '../common/getError'
import {orderBy } from '../common/orderby'
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import SeasonsEditor from './SeasonsEditor'
import SeasonSelector from './SeasonSelector'
import ScheduleSelector from './ScheduleSelector'
import SettingsIcon from '@material-ui/icons/Settings';
import MessageIcon from '@material-ui/icons/Message';
import WorkersEditor from './WorkersEditor';
import MissingWorkerProperties from './MissingWorkerProperties';
import {ReactComponent  as BusIcon} from '../../images/bus.svg';
import busIconImg from '../../images/bus.svg';
import busIconPng from '../../images/bus.png';
import {getLocationGroupFromLocation, getPlanLocationFromLocation} from './location_helpers'
import { format } from 'react-string-format';

function getTourDialogDefaults(locs)
{
  let res = {};
  locs.forEach(loc => {res[loc] = 1;})
  res["Tour/RN"] = 3;
  return res;
}

const styles = theme => ({
  editIcon:
      {
          display:"inline-block",
          padding: '4px',
          height:"20px",

      },
      uploadbutton:
      {
          padding: '0px'

      }
    });




function makeAvailableDateDictionary(arr)
{
  let result = {};
  arr.forEach(el => result[el.date+"-"+el.dateRestriction] = el.availability);
  return result;
}

class ScheduleCostList extends Component {
  static propTypes = {
    costs: PropTypes.array.isRequired
  };

  state = {
    detailsOpen: false,
    settingsOpen: false,
    workerDialogOpen: undefined,
  }
  
  render() {
    let cost_sum = this.props.costs.reduce((total, cost) => { return total + cost.cost;},0);
    let diff_cost_sum = this.props.diffCosts && this.props.diffCosts.reduce((total, cost) => { return total + cost.cost;},0);;
    return <div style={{display:"inline-block"}}>
      <Dialog
    open={this.state.detailsOpen}
    onClose={() => this.setState({ detailsOpen: false })}
    aria-labelledby="form-dialog-title"
  >
    <DialogContent>
      {
        this.props.costs ? 
        <div>
        <ul>
        {orderBy(this.props.costs,c => [-c.cost]).map((c,idx) => <li key={idx}>{c.cost}: {c.reason}</li>)}
        </ul>
        {this.props.costs.length === 0 && <li>Alles super</li>}
        </div>
        :
        "alles super"

      }
      {
        this.props.diffCosts !== undefined ?
        (
        this.props.diffCosts ? 
        <div>
          Im Vergleich:
        <ul>
        {orderBy(this.props.diffCosts,c => [-c.cost]).map((c,idx) => <li key={idx}>{c.cost}: {c.reason}</li>)}
        {this.props.diffCosts.length === 0 && <li>Alles super</li>}
        </ul>
        </div>
        :
        "alles super"
        ): null

      }
      {this.props.additionalInfo}
    </DialogContent>
  </Dialog>
    {(cost_sum > 0 || diff_cost_sum > 0) && <Button 
      style={
        {lineHeight:0.75, color: this.props.diffCosts === undefined || cost_sum !== diff_cost_sum ? "#000": "#ccc"}
      } 
      onClick={() => {this.setState({detailsOpen: true});}}>
        K: {cost_sum}{diff_cost_sum !== undefined && diff_cost_sum !== cost_sum && <span>({cost_sum > diff_cost_sum && "+"}{cost_sum-diff_cost_sum})</span>}</Button>}
</div>
;
  }
};

export class DefaultPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {}

  format_data()
  {
    return {...this.props.home, 
      schedule: this.props.home.schedules &&this.props.home.selectedSchedules && this.props.home.selectedSchedules["main"] &&  this.props.home.schedules[this.props.home.selectedSchedules["main"]],
      diff_schedule: this.props.home.schedules &&this.props.home.selectedSchedules && this.props.home.selectedSchedules["diff"] &&  this.props.home.schedules[this.props.home.selectedSchedules["diff"]]};

  }

  

  getFirstName(name)
  {
    if (!name) return "";
    let parts = name.split(" ");
    if (parts.length <= 1)return name;
    return parts[0];
  }
  
  componentWillUnmount() {
    console.log("clear timer ");
    clearInterval(this.lroTimer);
  }
  
  getPendingSchedule()
  {
    let minScheduleWithPending = undefined;
    if (!this.props)
      return minScheduleWithPending;
      if (!this.props.home)
      return minScheduleWithPending;
      if (!this.props.home.schedules)
      return minScheduleWithPending;
    for (let schedule of Object.values(this.props.home.schedules))
    {
      if (schedule.pendingSchedulingId)
      {
        if (minScheduleWithPending === undefined 
          || minScheduleWithPending.Id > schedule.Id)
          minScheduleWithPending = schedule;

      }

    }
    return minScheduleWithPending;
  }

  updateSchedule()
  {
    let minScheduleWithPending = this.getPendingSchedule();
    
    if (minScheduleWithPending !== undefined)
      this.props.actions.readSchedulingResult(minScheduleWithPending);    
    
    
    

  }

  fetchData()
  {
    if (!this.props.home.seasons && !this.props.home.fetchModelDataPending && !this.props.home.fetchModelDataError) {
      this.props.actions.fetchModelData();
    }
    for (let key of ["main","diff"])
    {
      if (this.props.home.selectedSchedules)
      if (this.props.home.selectedSchedules 
        && this.props.home.selectedSchedules[key]
        
        && !this.props.home.schedules[this.props.home.selectedSchedules[key]].scheduleAssignments
        && !(this.props.home.fetchSchedulePending && this.props.home.fetchSchedulePending[this.props.home.selectedSchedules[key]])
        && !(this.props.home.fetchScheduleError  && this.props.home.fetchScheduleError[this.props.home.selectedSchedules[key]])
        ) {
        this.props.actions.fetchSchedule(this.props.home.selectedSchedules[key]);
      }
    }
   
  }
  componentDidUpdate() {
    this.fetchData();
  }

  componentDidMount() {
   this.fetchData();
    this.lroTimer = setInterval(this.updateSchedule.bind(this), 5000);

  }

  buildWorkerCostInfo(worker)
  {
    return <ul>
    {Object.values(this.props.home.workerAvailabilityFrequencies).filter(waf => waf.workerId === worker.id).map(waf => <li key="waf">{`Möchte zwischen ${waf.minNumAvailableDays}x und ${waf.maxNumAvailableDays}x eingeteilt werden`}</li> )}
    {Object.values(this.props.home.workerLocationAvailabilities).filter(wlf => (wlf.workerId === worker.id)&& (wlf.availability > 0)&& (wlf.availability < 3) ).map(waf => <li key={"wlf"+waf.id}>{waf.availability === 1 ? `Nur in Ausnahmen in ${waf.location}` :  `Nicht ganz so gern in ${waf.location}`}</li> )}
    {Object.values(this.props.home.workerRoleAvailabilities).filter(wra => (wra.workerId === worker.id)&& (wra.availability > 0)&& (wra.availability < 3) ).map(wra => <li key={"wra"+wra.id}>{wra.availability === 1 ? `Nur in Ausnahmen als ${wra.roles.join('+')}` :  `Nicht ganz so gern als  ${wra.roles.join('+')}`}</li> )}    
    </ul>;
  }

  is_worker_unavailable(plan_keys, worker_data)
  {
    for (let plan_key of plan_keys)
    {
      if (worker_data.availableDateKeys[plan_key] > 0)
        return false;
    }
    return true;
  }
  
  handleChangeUploadMode(evt)
  {
    this.props.actions.setUploadMode(evt.target.checked);
  }

  getPlanKeys(seasonId, displayedSchedules)
  {
    
    
    let all_plan_keys = {};
    let all_role_keys = {};
    
    let role_key_to_display = {};
    let role_key_to_plan_id = {};
    let role_key_to_location = {};

    let date_key_to_date_and_restriction = {};

    let date_and_loc_to_date_restriction = {};
    
    let season = this.props.home.seasons[seasonId];

    let planIdsInSchedule  = {};
    if (displayedSchedules)
    {
      for (let schedule of displayedSchedules)
      {
        if (!schedule)
          continue;
        if (!schedule.scheduleAssignments)
          continue;
        for (let ass of schedule.scheduleAssignments)
        {
          planIdsInSchedule[ass.planId] = true;
        }
      }

    }

    let plansInSeason =  Object.values(this.props.home.plans).filter(p => (p.teamRequired || (planIdsInSchedule[p.id])) &&  p.date>= season.from && p.date <= season.to);

    console.log({plansInSeason})

    if (displayedSchedules)
    {
      console.log({displayedSchedules})
    for (let plan of plansInSeason)
    {
      
      let planLocs = new Set(displayedSchedules.filter(s => s !== undefined && s.scheduleAssignments).map(s => s.scheduleAssignments.filter(sa => sa.planId === plan.id).map(sa => sa.location)).flat());
      if (planLocs.size === 0)
        planLocs.add(plan.location + "/");
        
      console.log({planLocs, plan});
      for (let planLoc of planLocs)
      {
        let assignmentKey = moment.utc(plan.date).format("YYYY-MM-DD") + " " + planLoc;
        role_key_to_display[assignmentKey] = planLoc + " " +  moment.utc(plan.date).format("DD.MM.");
        let plan_key = plan.date+"-"+plan.dateRestriction;
        date_key_to_date_and_restriction[plan_key] = {date: plan.date, dateRestriction: plan.dateRestriction};
        all_plan_keys[plan_key] = true;
        all_role_keys[assignmentKey] = true;
        role_key_to_plan_id[assignmentKey] = plan.id;
        role_key_to_location[assignmentKey] = planLoc;
        date_and_loc_to_date_restriction[plan.date + plan.location] = plan.dateRestriction;
      }
      
    }
  }
    let all_plan_keys_array = Object.keys(all_plan_keys).sort();
    let filtered_locations = getEnabledFilters(this.props.home.filterables, "locations").enabledFilters;
    let all_keys_roles = Object.keys(all_role_keys).filter(k => filtered_locations.includes(role_key_to_location[k])).sort();
      
    return {
      all_plan_keys_array, 
          all_keys_roles, 
          role_key_to_plan_id,
          role_key_to_display,
          date_key_to_date_and_restriction,
          date_and_loc_to_date_restriction
    };

  }

  getScheduleData(data, schedule, date_and_loc_to_date_restriction)
  {
    {
    //console.log({dal: date_and_loc_to_date_restriction});


    let worker_data = {};
    Object.values(data.workers).forEach(w => 
      worker_data[w.id] = {
      worker: w,
      scheduleAssignments: {},
      scheduleAssignmentObjects: {},
      assignmentDirty: {},
      availableDateKeys : makeAvailableDateDictionary(Object.values(data.workerDateAvailabilities).filter(wda => wda.workerId === w.id)),
      locations: {},
      roles: {},
      roleCombinations: []
    });

    
    Object.values(data.workerLocationAvailabilities).forEach(wla => {if (wla.availability > 0) {worker_data[wla.workerId].locations[wla.location] = true;}});
    Object.values(data.workerRoleAvailabilities).forEach(wra => {
      if (wra.availability > 0) 
      {
        wra.roles.forEach(role => {worker_data[wra.workerId].roles[role] = true;});
      }
      worker_data[wra.workerId].roleCombinations.push(wra.roles);
    });  

    schedule.scheduleAssignments.forEach(a => 
      {
        /*if (date_and_loc_to_date_restriction[a.date+a.location] === undefined)
        {
          console.log("no dal for " + a.date+a.location);
        }*/
        let assignmentKey = a.date+"-"+date_and_loc_to_date_restriction[a.date+getPlanLocationFromLocation(a.location)];
        
        worker_data[a.workerId].assignmentDirty[assignmentKey] = a.dirty;
        if (!a.location || (a.roles.length === 0))
          return;
        let assignment_value = a.location + ": " + a.roles.join("/");
        worker_data[a.workerId].scheduleAssignments[assignmentKey] = assignment_value;
        worker_data[a.workerId].scheduleAssignmentObjects[assignmentKey] = a;
        
      });
      


    
    let roles_data = {};
    Object.values(data.allRoles).forEach(r => 
      roles_data[r.name] = {
      role: r,
      scheduleAssignments: {}
    });

    schedule.scheduleAssignments.forEach(a => 
      {
        if (!a.location || (a.roles.length === 0))
          return;
        let assignmentKey = moment.utc(a.date).format("YYYY-MM-DD") + " " + a.location;
        
        
        a.roles.forEach(r => {
          if (!roles_data[r])
          {
            console.log("no roles_data for " + r);
            console.log({r});
          }
        if (!roles_data[r].scheduleAssignments[assignmentKey])
          roles_data[r].scheduleAssignments[assignmentKey] = [];
        roles_data[r].scheduleAssignments[assignmentKey].push(a.workerId);
        });

      });
      

      let hasUnlockedAssignments = schedule.scheduleAssignments.some(sa => !sa.wasUploaded && !sa.locked && sa.location);
      let hasLockedAssignments = schedule.scheduleAssignments.some(sa => !sa.wasUploaded && sa.locked && sa.location);
      

      let result = { worker_data, 
          roles_data, 
          hasLockedAssignments,
          hasUnlockedAssignments,
          
      };
      //console.log({result});
      return result;
    }
  }

  joinAssignments(assignments, data)
  {
    if (!assignments)
      return "-";
    let workers = assignments.map(w => data.workers[w].name);
    workers.sort();  
    return workers.join(", ");
  }

  getRoleAssignments(planKey, row, diff_data, data)
  {
    let roleKey = row.role.name;
    let diffRow = diff_data && diff_data.roles_data && diff_data.roles_data[row.role.name];
    //console.log({roleKey, diffRow, diff_data, rd: diff_data && diff_data.roles_data});
    return {
      assignments: this.joinAssignments(row.scheduleAssignments[planKey], data),
      diffAssignments: diffRow && diffRow.scheduleAssignments
                          && this.joinAssignments(diffRow.scheduleAssignments[planKey], data)
    };
  }

  render() {
    var startTime = window.performance.now();
    console.log("starting render");
    

    if (this.props.home.fetchModelDataError)
    {
      return <div><div>{getError(this.props.home.fetchModelDataError)}</div>
      <div>Gehe zur <a href="..">Umfrage-Seite</a> um dich einzuloggen.</div>
      </div>
    }

    let data = this.format_data();
    if (!data || !data.workers)
    {
      return "Lade...";
    }

    console.log({data});

    

    let {enabledFilters} = getEnabledFilters(this.props.home.filterables, "roles");
    let filtered_roles = enabledFilters; 
     
    let filtered_locations = getEnabledFilters(this.props.home.filterables, "locations").enabledFilters;
    let filtered_location_groups = filtered_locations.map(loc => getLocationGroupFromLocation(loc));
    let filtered_unavailable = getEnabledFilters(this.props.home.filterables, "unavailable").enabledFilters;;
    let rows_by_roles = undefined;
    let rows_by_worker = undefined;

    const {
      all_plan_keys_array, 
          all_keys_roles, 
          role_key_to_plan_id,
          role_key_to_display,
          date_key_to_date_and_restriction,
          date_and_loc_to_date_restriction
    } = this.props.home.currentSeasonId ? this.getPlanKeys(this.props.home.currentSeasonId, [data.schedule, data.diff_schedule]) : {};
    
      const { worker_data, 
        roles_data, 
        hasLockedAssignments,
        hasUnlockedAssignments,
        } = (data.schedule && data.schedule.scheduleAssignments) ? this.getScheduleData(data, data.schedule, date_and_loc_to_date_restriction) : {};

        console.log({worker_data});

        let diff_data  = (data.diff_schedule && data.diff_schedule.scheduleAssignments) ? this.getScheduleData(data, data.diff_schedule, date_and_loc_to_date_restriction) : {};
        //console.log({diff_data});

        let filteredWorkerData = {};

        if ((data.schedule && data.schedule.scheduleAssignments))
        {

    let styles = [{backgroundColor:"#ffccca"}, {backgroundColor:"#ffdcba"}, {backgroundColor:"#ffeda1"}, {backgroundColor:"#d1f3d1"}];
    let styles_first_col = {width:"320px"};

     filteredWorkerData = orderBy(Object.values(worker_data), wd => wd.worker.name)
    .filter(wd => filtered_roles.some(r => wd.roles[r])) //filter by role
    .filter(wd => filtered_location_groups.some(loc => wd.locations[loc])) //filter by location
    .filter(wd => !this.is_worker_unavailable(all_plan_keys_array,wd) || filtered_unavailable.some(status => status === wd.worker.status)) //filter by showUnavailable;

    console.log({filteredWorkerData,all_plan_keys_array});
    console.log({fil2 : Object.values(worker_data).filter(w => w.worker.name.includes("Se"))});
    console.log({fil2r: Object.values(this.props.home.workerRoleAvailabilities).filter(wra => (wra.workerId == 221 || wra.workerId==213))});

    rows_by_worker = filteredWorkerData
    .map( (r, workerIndex) => ({columns: [<div><a href={"/worker-config/"+r.worker.id} target={"blank"}>{r.worker.name}</a><IconButton className={this.props.classes.uploadbutton} onClick={() => {this.setState({workerDialogOpen:r.worker.id});if (!this.props.home.workers[r.worker.id].email) this.props.actions.fetchEmail(r.worker.id, r.worker.planningCenterId);}}><MessageIcon /></IconButton>
      <ScheduleCostList key={workerIndex} 
        costs={data.schedule.scheduleCosts.filter(c => c.workerId === r.worker.id)} 
        diffCosts={data.diff_schedule &&data.diff_schedule.scheduleCosts && data.diff_schedule.scheduleCosts.filter(c => c.workerId === r.worker.id)}
        additionalInfo = {this.buildWorkerCostInfo(r.worker)}
        />
        {
          this.props.home.uploadMode && 
          <IconButton className={this.props.classes.uploadbutton}
        onClick={() => {console.log("clicked");this.props.actions.publishAssignments({workerId:r.worker.id, scheduleId: data.schedule.id})}}
        ><PublishIcon /></IconButton>
        }
        </div>]
        .concat(all_plan_keys_array.map(k => ((r.availableDateKeys[k] > 0)
                                              || (r.scheduleAssignmentObjects[k] && r.scheduleAssignmentObjects[k].wasUploaded)
                                              || (r.scheduleAssignments[k])
                                              || (diff_data && diff_data.worker_data && diff_data.worker_data[r.worker.id] && diff_data.worker_data[r.worker.id].scheduleAssignments[k]) ? 
          <div>
              <Button disabled={r.scheduleAssignmentObjects[k] && r.scheduleAssignmentObjects[k].wasUploaded} 
                      key={"btn_"+workerIndex+k} 
                      style={{  lineHeight:0.75,
                                 textTransform:"none", 
                                 fontWeight: r.assignmentDirty[k] ? "bold":"normal", 
                                color: diff_data && diff_data.worker_data && diff_data.worker_data[r.worker.id] ? 
                                          (diff_data.worker_data[r.worker.id].scheduleAssignments[k] != r.scheduleAssignments[k] ? "#000" : "#999")
                                          : "#000" }
                          } 
                    onClick={() => this.props.actions.setAssignmentFormOpen(data.schedule, r.worker, date_key_to_date_and_restriction[k].date, r.roleCombinations, Object.keys(r.locations), true)}>
                      {r.scheduleAssignments[k] ? r.scheduleAssignments[k] : (r.availableDateKeys[k] > 0 ? (r.assignmentDirty[k] ? "XXX" : "---") : "")}
              </Button>
              {
              this.props.home.uploadMode && !r.assignmentDirty[k] && r.scheduleAssignmentObjects[k] && !r.scheduleAssignmentObjects[k].wasUploaded && 
                <IconButton className={this.props.classes.uploadbutton}
                  onClick={() => {console.log("clicked");this.props.actions.publishAssignments({scheduleAssignmentId:r.scheduleAssignmentObjects[k].id, scheduleId: data.schedule.id})}}
                  ><PublishIcon />
                </IconButton>
              }
              {
                r.scheduleAssignmentObjects[k] && !r.scheduleAssignmentObjects[k].wasUploaded && r.scheduleAssignmentObjects[k].locked && <Tooltip title="festgelegt"><LockIconOutlined fontSize="small" /></Tooltip>
              }
              {
                r.scheduleAssignmentObjects[k] && r.scheduleAssignmentObjects[k].wasUploaded && <Tooltip title="hochgeladen"><LockIcon fontSize="small" /></Tooltip>
              }
              {
                diff_data && diff_data.worker_data && diff_data.worker_data[r.worker.id] && diff_data.worker_data[r.worker.id].scheduleAssignments[k] != r.scheduleAssignments[k] &&
              <span><big>({diff_data.worker_data[r.worker.id].scheduleAssignments[k] ? diff_data.worker_data[r.worker.id].scheduleAssignments[k] : "--"})</big></span>
              }
          </div>
          : null))),
        styles:[styles_first_col].concat(all_plan_keys_array.map(k =>({...styles[r.availableDateKeys[k]], fontSize:"7pt", border:"1pt solid #aaa"})))
    }));
    //console.log({rows_by_worker, all_keys: all_plan_keys_array});

    //console.log({worker_data, all_plan_keys, date_key_to_date_and_restriction});
    console.log({roles_data, state: this.state, all_keys_roles});

      
    rows_by_roles = Object.values(roles_data)
      .map( r => (
          {columns: [r.role.name].concat(all_keys_roles.map(k => this.getRoleAssignments(k,r,diff_data,data))
      .map(ass => 
        {return <div 
        style={{color:(ass.diffAssignments === undefined) || ass.assignments != ass.diffAssignments ? "#000" : "#aaa" }} >
        {ass.assignments} 
      {ass.diffAssignments && ass.assignments !== ass.diffAssignments
      && <div>({ass.diffAssignments})</div> }
      </div>}))}))
      .concat({columns: ([false].concat(all_keys_roles)).map(k => 
      <ScheduleCostList 
        costs={data.schedule.scheduleCosts.filter(c => (c.planId !== undefined) && (c.planId === role_key_to_plan_id[k]))} 
        diffCosts={data.diff_schedule &&data.diff_schedule.scheduleCosts && data.diff_schedule.scheduleCosts.filter(c => (c.planId !== undefined) && (c.planId === role_key_to_plan_id[k]))}
        />
        )});
        console.log({rows_by_roles});
  }

  let hasPendingSchedulingOp = !!this.getPendingSchedule();

    let result = (
      <div className="home-default-page">
        <header className="app-header">
          <img src={imgHeader} className="app-logo" alt="logo" />

          
        </header>
        <div className="app-intro">
        <br />
        <div style={{width:"100%", textAlign:"right"}}>
        {!this.state.settingsOpen ? <Button variant="outlined" color="primary" className={this.props.classes.button}
        onClick={() => {this.setState({settingsOpen: true})}}
        > <SettingsIcon />&nbsp;Einstellungen</Button>:
        <Button variant="outlined" color="primary" className={this.props.classes.button}
        onClick={() => {this.setState({settingsOpen: false})}}
        > Zurück</Button>
        }
        &nbsp;
        </div>

{
  this.state.workerDialogOpen&& 

        <Dialog
    open={this.state.workerDialogOpen}
    onClose={() => this.setState({ workerDialogOpen: undefined })}
    aria-labelledby="form-dialog-title"
  >
    <DialogContent>
      {
        <div>
        <a href={"/worker-config/"+this.props.home.workers[this.state.workerDialogOpen].id} target={"blank"}>Konfigurationsseite für {this.props.home.workers[this.state.workerDialogOpen].name}</a> <br />
        {this.props.home.workers[this.state.workerDialogOpen].email 
         ? <div>
           
           <a href={format(this.props.home.webClientConfig.reminderEmail,this.props.home.workers[this.state.workerDialogOpen].email, this.getFirstName(this.props.home.workers[this.state.workerDialogOpen].name))}>Erinnerungs-Email senden</a>
           <a href={format(this.props.home.webClientConfig.generalEmail,this.props.home.workers[this.state.workerDialogOpen].email, this.getFirstName(this.props.home.workers[this.state.workerDialogOpen].name))}>Allgemeine Email senden</a>
         </div>
         : this.props.home.workers[this.state.workerDialogOpen].fetchEmailPending ? 
         <span>Lade E-Mail...<CircularProgress size={24}  /></span> : <span>{this.props.home.workers[this.state.workerDialogOpen].fetchEmailError ? getError(this.props.home.workers[this.state.workerDialogOpen].fetchEmailError) : "Keine Mail-Adresse bekannt."}</span>

        }
        </div>
        }
      
    </DialogContent>
  </Dialog>
    }

    {this.state.tourDialogOpen && 
    
    <Dialog
      open={this.state.tourDialogOpen}
      onClose={() => this.setState({ tourDialogOpen: undefined })}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent>
          <div>
            Wie viele Einsätze sollen in diesen Locations hinzugefügt werden?
            <form noValidate autoComplete='off'>
            {Object.values(this.props.home.allLocations).map(loc => loc.name).filter(loc => loc.startsWith("Tour")).map(loc => 
              <div>
                {loc.substr(5)}&nbsp;&nbsp;
                
<TextField
type="number"
  value={this.state.tourDialogValues[loc]}
  onChange={(evt) => {this.setState({tourDialogValues: {...this.state.tourDialogValues, [loc]: parseInt(evt.target.value,10)}});} }
/>
                </div>)}

                <Button variant="outlined" onClick={() => {this.props.actions.startScheduling(data.schedule, false, this.state.tourDialogValues); this.setState({ tourDialogOpen: undefined });}}>Planung starten</Button>
            </form>
            </div>
            </DialogContent>


    </Dialog>
    
    }
        
{this.state.settingsOpen ?
  <div>
  <SeasonsEditor close={() => this.setState({settingsOpen: false})} />
  <WorkersEditor />
  </div>
  : 
  <div>

        <Typography component="h1" variant="h4">Team-Einteilung</Typography>

        <div><div><SeasonSelector /> <ScheduleSelector scheduleKey={"main"} /> </div>
    {this.props.home.selectedSchedules && this.props.home.selectedSchedules["main"] && <div> Vergleichen mit: <ScheduleSelector scheduleKey={"diff"} emptyLabel={"Nicht vergleichen"} blacklisted={[this.props.home.selectedSchedules["main"]]}/></div>}</div> 
    
    {this.props.home.createScheduleError && <div class="fixed-bottom footer"><div class="alert alert-warning" role="alert">
  {getError(this.props.home.createScheduleError)}
</div></div>}

        {data.schedule && 
<Typography component="h2" variant="h5">Gesamtkosten: {data.schedule.totalCost} ({moment(data.schedule.creation).format("DD.MM. HH:mm")})</Typography>

        }

{!data.schedule && this.props.home.currentSeasonId > 0 && 
  Object.keys(this.props.home.schedules).filter(sId => this.props.home.schedules[sId].seasonId == this.props.home.currentSeasonId).length === 0 
  &&
  <div>
    Noch kein Plan erstellt. <br />

    

    <Button variant="outlined" onClick={() =>  {
      try
      {
        this.props.actions.createSchedule(this.props.home.currentSeasonId);
      }
      catch (e)
      {
        console.log({error: e});
      }
    }
    
    }>Plan erstellen</Button>
    </div>
}

        {data.schedule && data.schedule.scheduleAssignments&&
        <div>
        

        <FilterCombo filterId={"roles"} heading={"Position"}/>
        <FilterCombo filterId={"locations"} heading={"Standort"} />
        <FilterCombo filterId={"unavailable"} heading={"Auch nicht verfügbar"} />
        
        <br/>
        {(data.schedule.scheduleAssignments.some(sa => sa.dirty))
        &&
        <Button variant="outlined" color="primary" className={this.props.classes.button}
        onClick={() => {console.log("clicked");this.props.actions.saveSchedule(data.schedule)}}
        ><SaveIcon />Speichern</Button>
        }
&nbsp;
    { (hasLockedAssignments || hasUnlockedAssignments)
    && 
        <Button variant="outlined" color="primary" className={this.props.classes.button}
        onClick={() => {this.props.actions.clearSchedule(data.schedule)}}
        ><CancelIcon />{hasUnlockedAssignments && hasLockedAssignments ? "Nicht festgelegte Zuweisungen löschen" : "Alle Zuweisungen löschen"} </Button>
    }
        &nbsp;


        <Button variant="outlined" color="primary" className={this.props.classes.button}
        onClick={() => {this.props.actions.startScheduling(data.schedule, false)}}
        > {hasPendingSchedulingOp ? <CircularProgress size={24}  /> : <SyncIcon />}&nbsp;Grob planen</Button>
          &nbsp;
        <Button variant="outlined" color="primary" className={this.props.classes.button}
        onClick={() => {this.props.actions.startScheduling(data.schedule, true)}}
        > {hasPendingSchedulingOp ? <CircularProgress size={24}  /> : <SyncIcon />}&nbsp;Fein planen</Button>
          &nbsp;
          <Button variant="outlined" color="primary" className={this.props.classes.button}
        onClick={() => {this.setState({tourDialogOpen: true,
        tourDialogValues: getTourDialogDefaults(Object.values(this.props.home.allLocations).map(loc => loc.name).filter(loc => loc.startsWith("Tour")))
        });
        
      }}
        > {hasPendingSchedulingOp ? <CircularProgress size={24}  /> : <img src={busIconImg} style={{width:16, height:16}} className="app-logo" alt="logo" />}&nbsp;Touren hinzufügen</Button>
          &nbsp;
          {hasPendingSchedulingOp && <Button variant="outlined" color="primary"  className={this.props.classes.button}  onClick={() => {this.props.actions.cancelPendingScheduling()}}><CancelIcon />Laufende Planung verwerfen</Button> }&nbsp;
  {this.props.home.uploadMode
        &&
        <Button variant="outlined" color="primary" className={this.props.classes.button}
        onClick={() => {console.log("clicked");this.props.actions.publishAssignments({scheduleId: data.schedule.id})}}
        ><PublishIcon />Alles ins PCO laden</Button>
        }
&nbsp;

</div>
        }
        { (this.props.home.clearSchedulePending 
        || this.props.home.saveSchedulePending 
        || this.props.home.startSchedulingPending 
        || this.props.home.createSchedulePending 
        || this.props.home.publishAssignmentsPending
        || (this.props.home.selectedSchedules
          &&  this.props.home.selectedSchedules["main"]
          &&  this.props.home.fetchSchedulePending[this.props.home.selectedSchedules["main"]])
         )
        ?
        <LinearProgress /> 
        :
        <div style={{height:"6px"}} />}
        {data.schedule && data.schedule.scheduleAssignments && 
          <div>
<FormControlLabel
        control={
          <Checkbox checked={this.props.home.uploadMode} onChange={this.handleChangeUploadMode.bind(this)} value="uploadMode" />
        }
        label="Upload-Buttons anzeigen"
      />

                

      <div style={{height:"8px"}} />

      <div>
        {
          data.schedule && data.schedule.scheduleAssignments &&
          <div>
            {orderBy([...new Set(data.schedule.scheduleAssignments.map(sa => ({loc: sa.location, date: sa.date})).filter(sa => sa.loc.startsWith("Tour/"))
            .map(sa => moment.utc(sa.date).format("YYYY-MM-DD") + ": " + sa.loc))], x=>x)
            .map(sa => <div><InfoIcon />{sa}</div>)}
          </div>
        }

      {filteredWorkerData && 
        <MissingWorkerProperties workerIds={filteredWorkerData.map(w => w.worker.id)} />
      }

        <SimpleRawTable rows = {rows_by_worker} titleRow={["Name"].concat(all_plan_keys_array.map(k => moment.utc(date_key_to_date_and_restriction[k].date).format("DD.MM.")+" " + (date_key_to_date_and_restriction[k].dateRestriction || "")))} />
        

        <AssignmentForm schedule={data.schedule}/>
        <SimpleTable rows = {rows_by_roles} titleRow={["Name"].concat(all_keys_roles.map(k => <div>{role_key_to_display[k]}
          {
          this.props.home.uploadMode &&
          <IconButton className={this.props.classes.uploadbutton}
        onClick={() => {console.log("clicked");this.props.actions.publishAssignments({planId:role_key_to_plan_id[k], scheduleId: data.schedule.id})}}
        ><PublishIcon /></IconButton>
          }

        </div>))} />
        <CostStatistics schedule={data.schedule} diffSchedule={data.diff_schedule}/>
</div>
</div>

}

{this.props.home.readSchedulingResultError && <div class="fixed-bottom footer"><div class="alert alert-warning" role="alert">
{getError(this.props.home.readSchedulingResultError)}
</div> 
</div>}

{this.props.home.startSchedulingError && <div class="fixed-bottom footer"><div class="alert alert-warning" role="alert">
{getError(this.props.home.startSchedulingError)}
</div> 
</div>}


{data.schedule && data.schedule.schedulingError && <div class="fixed-bottom footer"><div class="alert alert-warning" role="alert">
  Fehler: {data.schedule.schedulingError}
</div></div>}




{data.diff_schedule && data.diff_schedule.schedulingError && <div class="fixed-bottom footer"><div class="alert alert-warning" role="alert">
Fehler beim Vergleichsplan: {data.diff_schedule.schedulingError}
</div></div>}


        {this.props.home.saveScheduleError && <div class="fixed-bottom footer"><div class="alert alert-warning" role="alert">
        {getError(this.props.home.saveScheduleError)}

        
        </div> 
        </div>}

        {this.props.home.publishAssignmentsError && <div class="fixed-bottom footer"><div class="alert alert-warning" role="alert">
        {getError(this.props.home.publishAssignmentsError)}


        
        </div> 
        </div>}
  
</div>}




        </div>
        
      </div>
    );

    

    console.log("render took: " + (window.performance.now() - startTime));
    return result;
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js